import { mapValues } from 'lodash-es';
import {
  AGENT_COMMISSION_TYPE_OPTIONS,
  NESTED_PLAYER_COMMISSION_FIELDS,
  PLAYER_COMMISSION_TYPE_OPTIONS,
} from '../../../constants';
import { CommissionType } from '../../../@types';
import { CommissionPicks } from '../../../@types/api';
import { COMMISSION_TYPES } from '../../../constants/commission';

export type CommissionFormData = {
  playerCommissionType?: CommissionType;
  playerCommissionPercentage?: string;
  partnerCommissionType?: CommissionType;
  partnerCommissionPercentage?: string;
  picks?: CommissionPicks<string>;
};

export type AgentCommissionPayload = {
  type?: CommissionType;
  percentage?: number;
  picks?: CommissionPicks<number>;
};

export type CommissionFieldConfig = {
  name: keyof CommissionFormData;
  label: string;
  type: 'select' | 'number' | 'picks-table';
  gridSize: number;
  allowDecimals?: boolean;
  displayCurrency?: boolean;
  options?: Array<{ id: string; name: string }>;
  nestedFields?: Partial<Record<string, CommissionFieldConfig[]>>;
};

export type CommissionConfig = {
  fields: CommissionFieldConfig[];
  defaultValues: CommissionFormData;
  prepareSubmitData: (formData: CommissionFormData) => AgentCommissionPayload;
};

export const agentCommissionConfig: CommissionConfig = {
  fields: [
    {
      name: 'partnerCommissionType',
      label: 'Partner commission type',
      type: 'select',
      gridSize: 9.5,
      options: AGENT_COMMISSION_TYPE_OPTIONS,
    },
    {
      name: 'partnerCommissionPercentage',
      label: '%',
      type: 'number',
      gridSize: 2.5,
      allowDecimals: true,
    },
    {
      name: 'playerCommissionType',
      label: 'Player commission type',
      type: 'select',
      gridSize: 9.5,
      options: PLAYER_COMMISSION_TYPE_OPTIONS,
      nestedFields: NESTED_PLAYER_COMMISSION_FIELDS,
    },
  ],
  defaultValues: {
    playerCommissionType: COMMISSION_TYPES.PER_PICK,
    playerCommissionPercentage: '',
    partnerCommissionType: COMMISSION_TYPES.POSITION,
    partnerCommissionPercentage: '',
    picks: {
      '1': '0',
      '2': '0',
      '3': '0',
      '4-7': '0',
      '8-9': '0',
      '10+': '0',
    },
  },
  prepareSubmitData: (data) => {
    const picks = data.picks ? mapValues(data.picks, (value) => Number(value) * 100) : undefined;
    return {
      type: data.playerCommissionType,
      percentage:
        data.playerCommissionType !== COMMISSION_TYPES.PER_PICK ? Number(data.playerCommissionPercentage) : undefined,
      picks,
    };
  },
};
